import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../shared/form/input-group')
);
import { isValidEmail } from '../../shared/util';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = {
            email: {
                value: null,
                error: null,
            },
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState != this.state) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (nextProps.submitted != this.props.submitted) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        return false;
    }

    render({ submitting, submitted, error }, { email }) {
        const img_src = 'https://gfx.tarot.com/images/site/animation/hierophant-password.gif';
        const disabled = !email.value || email.error || submitting;
        const button_class = disabled ? 'button disabled' : 'button';

        if (!submitted) {
            return (
                <password-reset>
                    <row className='is-wrap'>
                        <column className='is-6 is-push-6-desktop is-push-6-tablet is-12-mobile has-text-center'>
                            <img src={img_src} alt='The Hierophant' />
                        </column>
                        <column className='is-6 is-12-mobile has-text-center-mobile has-padding-10-mobile'>
                            <h6 className='has-text-boulder'>IT LOOKS LIKE YOU'RE LOCKED OUT</h6>
                            <h1 className='is-hidden-mobile'>Forgot your<br />password?</h1>
                            <h4 className='is-visible-mobile'>Forgot your password?</h4>
                            <p>
                                Let's get you a new one! Enter your email below and we'll get you back into your account
                                in no time.
                            </p>
                            <Suspense fallback={<div className='skeleton' />}>
                                <InputGroup
                                    name='email'
                                    type='email'
                                    placeholder='ENTER YOUR EMAIL ADDRESS'
                                    value={email.value}
                                    error={email.error || error}
                                    onInput={this.handleChange}
                                />
                            </Suspense>
                            <button className={button_class} disabled={disabled} onClick={this.submit}>
                                {submitting ? 'SUBMITTING…' : 'SEND RESET EMAIL'}
                            </button>
                        </column>
                    </row>
                </password-reset>
            );
        }

        return (
            <password-reset>
                <row className='is-wrap'>
                    <column className='is-6 is-push-6-desktop is-push-6-tablet is-12-mobile has-text-center'>
                        <img src={img_src} alt='The Hierophant' />
                    </column>
                    <column className='is-6 is-12-mobile has-text-center-mobile has-padding-10-mobile'>
                        <h6 className='has-text-boulder'>EMAIL SUBMITTED</h6>
                        <h1 className='is-hidden-mobile'>Your reset<br />email is on<br />its way!</h1>
                        <h4 className='is-visible-mobile'>Your reset email is on its way!</h4>
                        <p>
                            Instructions on how to reset your password have been sent to
                            <span className='has-text-size-20 fancy-title'> {email.value}</span>.
                        </p>
                        <hr />
                        <h6 className='has-text-boulder'>
                            WHAT IF I DON'T SEE OR GET MY EMAIL?
                        </h6>
                        <small>
                            Because each email provider is unique, we cannot guarantee your Password Reset email will
                            land in your inbox. If you do not see an email from us, please check your trash and spam
                            folders, to be sure it wasn't sent there by mistake. If you have any trouble, you can
                            always reach out to <a href='mailto:support@tarot.com'>support@tarot.com</a>.
                        </small>
                    </column>
                </row>
            </password-reset>
        );
    }

    handleChange = (e) => {
        this.validateEmail(e.target.value);
    }

    submit = () => {
        this.validateEmail(this.state.email.value);

        if (this.state.email.value && !this.state.email.error) {
            const payload = {
                email: this.state.email.value,
            };

            const order_uuid = (new URLSearchParams(window.location.search)).get('order');

            if (order_uuid) {
                payload.order_uuid = order_uuid;
            }

            this.props.initPasswordReset(payload);
        }
    }

    validateEmail = (email) => {
        let state = this.state;
        state.email.value = email;

        state.email.error = !isValidEmail(email) ? 'Please enter a valid email address' : null;

        this.setState(state);
    }
}

const mapStateToProps = (state) => ({
    submitting: state.form && state.form.submitting,
    submitted: state.form && state.form.submitted,
    error: state.form && state.form.error,
});

const mapDispatchToProps = (dispatch) => ({
    initPasswordReset: (payload) => dispatch({
        type: 'member:password-reset-init',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);